import { createLogic } from 'redux-logic'
import * as constants from '../constants'
import { map } from 'rxjs/operators'

export const getJobLogic = createLogic({
  type: constants.GET_USER_JOB_TITLE.ACTION,
  processOptions: {
    successType: constants.GET_USER.FULFILLED,
    failType: constants.GET_USER.REJECTED
  },
  process({ keycloak, http }) {
    const { tokenParsed = {} } = keycloak

    return http.get(`/api/microsoft/user/${tokenParsed.preferred_username}`).pipe(
      map(http.getBody),
      map(({ jobTitle }) => {
      /* eslint no-underscore-dangle: ["error", { "allow": ["_mtm", "_paq"] }]*/
        window._paq.push(['setCustomDimension', 3, jobTitle])
        window._paq.push(['trackPageView'])

        return {
          jobTitle
        }
      })
    )
  }
})
